<script setup lang="ts">
import { TranslationService } from "../services/translation.service";
import { inject, ref } from "vue";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { categories, consultants } = defineProps({
    categories: {
        type: Array,
        required: true,
    },
    consultants: {
        type: Array,
        required: true,
    },
});

const activeCategory = ref(0);
const activeConsultants = ref(consultants);

const sliderEl = ref<JQLite>();

const selectConsultantCat = (id: number) => {
    consultants.categorySlug = id;
    activeCategory.value = id;

    if (id === 0) {
        $(sliderEl.value)?.slick("slickUnfilter");
    } else {
        $(sliderEl.value)?.slick("slickUnfilter");
        window.requestAnimationFrame(() => {
            $(sliderEl.value)?.slick("slickFilter", `.consultant-cat-${id}`);
        });
    }
};

function consultantCatClasses(categories: Array<any>): string {
    const outArr = categories.map((el) => `consultant-cat-${el}`);
    return outArr.join(" ");
}
</script>
<template>
    <!-- {{ activeCategory }} -->
    <div class="row-xl-1-2 col-xl-3-21 col-l-2-22 col-m-3-21 col-s-1-23 pb-10">
        <div class="categories-bar mt-15 mb-15">
            <ul>
                <li
                    v-for="item in categories"
                    class="categories-bar-item"
                    :class="{ active: activeCategory === item.id }"
                >
                    <span @click="selectConsultantCat(item.id)">{{
                        item.title
                    }}</span>
                </li>
            </ul>
        </div>
    </div>
    <div class="row-xl-2-3 col-xl-2-22 consultants-slider-outer">
        <div
            class="slider-simple"
            ref="sliderEl"
            data-responsive='[
				 	{
						"breakpoint": 9999,
						"settings": {
							"slidesToShow": 5
						}
					},
					{
					 "breakpoint": 1401,
					 "settings": {
						 "slidesToShow": 4
					 }
				 },
					{
						"breakpoint": 1201,
						"settings": {
							"slidesToShow": 3
						}
				  },
				  {
					  "breakpoint": 769,
						"settings": {
							"slidesToShow": 2
						}
					},
					{
						"breakpoint": 501,
						"settings": {
							"slidesToShow": 1
						}
				 	}
				]'
        >
            <div
                v-for="cons in activeConsultants"
                class="consultant-cell"
                :class="consultantCatClasses(cons.consultantAreaCategories)"
            >
                <a
                    class="grid-css box-consultant box-shadow"
                    :href="`mailto:${cons.email}`"
                >
                    <div class="row-xl-0-1 col-xl-0-24">
                        <div
                            class="bg-img__square"
                            :style="{
                                backgroundImage: `url(${cons.mainImage})`,
                            }"
                        ></div>
                    </div>
                    <div class="row-xl-1-2 col-xl-2-22 pt-10 pb-3">
                        <div
                            class="normal text-small color-cb"
                            v-html="cons.jobPosition"
                        ></div>
                        <div class="bold mb-5">{{ cons.title }}</div>

                        <div
                            v-if="cons.ausbildung"
                            class="italic normal text-small color-cb mt-5 mb-5"
                            v-html="cons.ausbildung"
                        ></div>
                        <div class="normal text-small">
                            {{ t("CONSULTANTS_REGION") }}
                            {{ cons.consultantRegions }}
                        </div>
                    </div>
                    <div class="cell-bottom cell-right row-xl-2-3 col-xl-0-24">
                        <div class="btn-mail btn-large"></div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
